import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Backdrop from "Components/Common/Backdrop";
import PermanentConnectionRefundCalculations from "./PermanentConnectionRefundCalculations";
import TemporaryConnectionRefundCalculations from "./TemporaryConnectionRefundCalculations.js";
import Modal from "Components/Common/Modal";

import { useGetUtilityConsumerApplicationsQuery } from "apis/UtilityConsumer/utilityConsumer";

const RefundCalculations = ({
  t,
  utilityConsumerId,
  applicationId,
  handleClose,
}) => {
  const { data: { data: applicationsData } = {}, isLoading } =
    useGetUtilityConsumerApplicationsQuery(utilityConsumerId);

  if (isLoading) {
    return <Backdrop open />;
  }
  return (
    <Modal
      isOpen
      handleClose={handleClose}
      title={t("Refund Calculations")}
      maxWidth="lg"
    >
      {applicationsData?.isTemporaryConnection ? (
        <TemporaryConnectionRefundCalculations
          applicationsData={applicationsData ?? {}}
          applicationId={applicationId}
          utilityConsumerId={utilityConsumerId}
          handleClose={handleClose}
        />
      ) : (
        <PermanentConnectionRefundCalculations
          applicationId={applicationId}
          utilityConsumerId={utilityConsumerId}
          handleClose={handleClose}
        />
      )}
    </Modal>
  );
};

export default withTranslation()(RefundCalculations);

RefundCalculations.propTypes = {
  t: PropTypes.func,
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
  utilityConsumerId: PropTypes.number,
};
